'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { 'data-autofocus-inside': !disabled },
    children
  );
};

AutoFocusInside.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool
};

AutoFocusInside.defaultProps = {
  disabled: false
};

exports.default = AutoFocusInside;